// store.js
import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./REACT/SLICES/Userslice";
import prcReducer from "./REACT/SLICES/PRCslice";

export const store = configureStore({
  reducer: {
    User: userReducer,
    PRC: prcReducer,
  },
});
